export default __webpack_public_path__ + "static/media/DOLA.574836e6.svg";